import api from './api';

export interface User {
  id: string;
  first_name: string;
  family_name: string;
  email?: string;
  role: string;
  client_id?: string;
  username?: string;
  last_connected: string | null;
  created_date: string;
  last_updated: string;
  assigned_projects?: string[];  // Array of project IDs user is assigned to
}

export interface CreateUserRequest {
  first_name: string;
  family_name: string;
  email?: string;
  role: string;
  client_id?: string;
  username?: string;
}

export interface UpdateUserRequest {
  first_name?: string;
  family_name?: string;
  email?: string;
  role?: string;
  client_id?: string;
  username?: string;
  last_connected?: string | null;
}

export const userService = {
  async getAll(): Promise<User[]> {
    const response = await api.get<User[]>('/users/');
    return response.data;
  },

  async getById(id: string): Promise<User> {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },

  async create(data: CreateUserRequest): Promise<User> {
    // Filter out empty strings and convert them to undefined
    const cleanedData = {
      ...data,
      email: data.email || undefined,
      client_id: data.client_id || undefined,
      username: data.username || undefined,
    };
    const response = await api.post<User>('/users/', cleanedData);
    return response.data;
  },

  async update(id: string, data: UpdateUserRequest): Promise<User> {
    // Filter out empty strings and convert them to undefined
    const cleanedData = {
      ...data,
      email: data.email || undefined,
      client_id: data.client_id || undefined,
      username: data.username || undefined,
    };
    const response = await api.put<User>(`/users/${id}`, cleanedData);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },
};
